import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Card, Col, ConfigProvider, Modal, Row, Tabs } from "antd";
import { Flex } from "antd/lib";
import PaymentStatus from "components/elements/TagCustom/PaymentStatus";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const PayrollPerMonthModal = ({
    visible = false,
    loading = false,
    isOpen = false,
    onCancel = () => { },
    payrollPerMonth = [],
    getPayrollPeriodDetails = () => { },
    onViewPayrollPeriodCalculateDetails = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState();

    const groupedPayroll = useMemo(() => {
        return payrollPerMonth?.reduce((acc, item) => {
            item?.dataList?.forEach((data) => {
                const key = i18n.language === "en" ? data?.employment?.nameEn : data?.employment?.name || "อื่นๆ";
                if (!acc[key]) acc[key] = [];
                acc[key].push(data);
            });
            return acc;
        }, {});
    }, [payrollPerMonth]);

    const getEyesIcon = useCallback(() => {
        return isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />
    }, [isVisible])

    const MENU = useMemo(() => {
        return Object.keys(groupedPayroll || {}).map((key) => ({
            label: key,
            key: key,
        }));
    }, [groupedPayroll]);



    return (
        <Modal
            open={isOpen}
            onCancel={onCancel}
            footer={null}
            width={1200}
            centered
            maskClosable={false}
            closable={false}
        >
            <ConfigProvider>
                <Tabs defaultActiveKey={MENU[0]?.key}>
                    {MENU.map((menu) => (
                        <Tabs.TabPane tab={menu.label} key={menu.key}>
                            {groupedPayroll[menu.key]?.map((payrollPeriod, index) => (
                                console.log("payrollPeriod", payrollPeriod),

                                <Card
                                    loading={loading}
                                    key={index}
                                    style={{
                                        borderStyle: "solid",
                                        borderWidth: "3px",
                                        borderColor: "rgba(204, 204, 204, 0.8)",
                                        marginTop: "3vh",
                                        marginBottom: "3vh"

                                    }}
                                >
                                    <Row gutter={[24, 16]} align="middle">
                                        <Col span={24}>
                                            <Flex justify="space-between">
                                                <Flex vertical >
                                                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                                                        {t('payment_period.label.period') + " " + dayjs(payrollPeriod?.month?.length < 2 ? "0" + payrollPeriod?.month : payrollPeriod?.month, "MM").format("MMMM")}
                                                        {" (" + menu.label + ")"}
                                                    </span>
                                                </Flex>
                                                <Flex >
                                                    <span onClick={() => onViewPayrollPeriodCalculateDetails(payrollPeriod?.id)} style={{ fontSize: "16px", fontWeight: "bold", cursor: "pointer" }}>
                                                        <u>{t("news.label.description")}</u>
                                                    </span>
                                                </Flex>
                                                <Flex justify="space-between" onClick={() => setIsVisible(prevVisible => !prevVisible)} style={{ cursor: "pointer" }}>
                                                    {/* <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                                                        <u>{t("news.label.description")}</u>
                                                    </span> */}
                                                    {getEyesIcon()}
                                                </Flex>

                                            </Flex>
                                        </Col>

                                        <Col style={{ alignSelf: "start" }} span={12}>
                                            <Row gap={40}>
                                                <Col span={12}>
                                                    <Flex align="center" justify="end" gap={16}>
                                                        <PaymentStatus
                                                            paymentStatus={
                                                                i18n.language === "en"
                                                                    ? payrollPeriod.statusFlagResp.nameEn
                                                                    : payrollPeriod.statusFlagResp.name
                                                            }
                                                        />
                                                    </Flex>
                                                </Col>
                                                <Col span={12}>
                                                    <Flex align="start" justify="center" gap={16} style={{ textAlign: "right", margin: "8px" }}>
                                                        <span>{t('payment_period.label.periodAt')} {payrollPeriod.periodNo}</span>
                                                    </Flex>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col span={12}>
                                            <Row spen={12}>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span>
                                                            {t('payment_period.label.payment_date')}
                                                        </span>
                                                    </Flex>
                                                </Col>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span>
                                                            {dayjs(payrollPeriod.paymentDate)
                                                                .add(i18n.language === "en" ? 0 : 543, "year")
                                                                .format("DD/MM/YYYY")}
                                                        </span>
                                                    </Flex>
                                                </Col>
                                            </Row>
                                            <Row spen={12}>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span >{t('payment_period.label.period_range')}</span>

                                                    </Flex>
                                                </Col>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span>   {dayjs(payrollPeriod.startPeriod).add(i18n.language === "en" ? 0 : 543, "year").format("DD/MM/YYYY")} -{" "}
                                                            {dayjs(payrollPeriod.endPeriod).add(i18n.language === "en" ? 0 : 543, "year").format("DD/MM/YYYY")}</span>

                                                    </Flex>
                                                </Col>
                                            </Row>
                                            <Row spen={12}>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span>{t('payment_period.label.total_employee')}</span>

                                                    </Flex>
                                                </Col>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span>{payrollPeriod.employee || 0} {i18n.language === "en" ? "" : "คน"}</span>
                                                    </Flex>
                                                </Col>
                                            </Row>
                                            <Row spen={12}>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span style={{ fontWeight: "bold" }}>{t('payment_period.label.net_amount')}</span>


                                                    </Flex>
                                                </Col>
                                                <Col span={12}>
                                                    <Flex align="center" justify="center" gap={16} style={{ margin: "8px", justifySelf: "left" }}>
                                                        <span style={{ fontWeight: "bold" }}> {isVisible ? get2DecimalPointsWithCommas(payrollPeriod.totalPaid) + " " + t("unit.baht") : "xxx,xxx" + " " + t("unit.baht")}
                                                        </span>

                                                    </Flex>
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>


                                </Card>
                            ))}
                            <Row>
                                <Col style={{ textAlign: "center" }} span={24}>
                                    <Button htmlType="submit"
                                        type="primary"
                                        onClick={onCancel}
                                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: "var(--button-color)" }}>
                                        {t("common.close")}
                                    </Button>
                                </Col>
                            </Row>
                        </Tabs.TabPane>
                    ))}


                </Tabs>
            </ConfigProvider >
        </Modal >
    );
};

export default PayrollPerMonthModal;
